export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 76 76" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-1110.000000, -4926.000000)">
                    <g id="编组-2" transform="translate(510.000000, 4798.000000)">
                        <g id="Induciton-Cooker_icon" transform="translate(600.000000, 128.000000)">
                            <rect id="矩形" x="0" y="0" width="76" height="76"></rect>
                            <g id="编组-10" transform="translate(16.000000, 11.000000)">
                                <path
                                    d="M6.04761905,50.1136364 C7.07329073,50.1136364 7.9047619,49.2894332 7.9047619,48.2727272 C7.9047619,47.2560212 7.07329073,46.4318182 6.04761905,46.4318182 C5.02194737,46.4318182 4.19047619,47.2560212 4.19047619,48.2727272 C4.19047619,49.2894332 5.02194737,50.1136364 6.04761905,50.1136364 Z"
                                    id="椭圆形"
                                    fill="#000000"
                                    fillRule="nonzero"
                                ></path>
                                <path
                                    d="M12.2380952,50.1136364 C13.2637669,50.1136364 14.0952381,49.2894332 14.0952381,48.2727272 C14.0952381,47.2560212 13.2637669,46.4318182 12.2380952,46.4318182 C11.2124236,46.4318182 10.3809524,47.2560212 10.3809524,48.2727272 C10.3809524,49.2894332 11.2124236,50.1136364 12.2380952,50.1136364 Z"
                                    id="椭圆形备份-18"
                                    fill="#000000"
                                    fillRule="nonzero"
                                ></path>
                                <path
                                    d="M18.4285714,50.1136364 C19.454243,50.1136364 20.2857143,49.2894332 20.2857143,48.2727272 C20.2857143,47.2560212 19.454243,46.4318182 18.4285714,46.4318182 C17.4028997,46.4318182 16.5714286,47.2560212 16.5714286,48.2727272 C16.5714286,49.2894332 17.4028997,50.1136364 18.4285714,50.1136364 Z"
                                    id="椭圆形备份-19"
                                    fill="#000000"
                                    fillRule="nonzero"
                                ></path>
                                <path
                                    d="M24.6190476,50.1136364 C25.6447193,50.1136364 26.4761904,49.2894332 26.4761904,48.2727272 C26.4761904,47.2560212 25.6447193,46.4318182 24.6190476,46.4318182 C23.593376,46.4318182 22.7619048,47.2560212 22.7619048,48.2727272 C22.7619048,49.2894332 23.593376,50.1136364 24.6190476,50.1136364 Z"
                                    id="椭圆形备份-20"
                                    fill="#000000"
                                    fillRule="nonzero"
                                ></path>
                                <rect
                                    id="矩形"
                                    fill="#000000"
                                    fillRule="nonzero"
                                    x="30.1904762"
                                    y="46.9757099"
                                    width="9.90476191"
                                    height="2.45454545"
                                    rx="1.15198942"
                                ></rect>
                                <line x1="3.58203767e-13" y1="42.9545455" x2="44" y2="42.9545455" id="路径-2" stroke="#000000" strokeWidth="2.09462914"></line>
                                <path
                                    d="M22.2153502,30.6818182 C27.6855991,30.6818182 32.1201121,26.2860685 32.1201121,20.8636363 C32.1201121,15.4412043 27.6855991,11.0454546 22.2153502,11.0454546 C16.7451013,11.0454546 12.3105883,15.4412043 12.3105883,20.8636363 C12.3105883,26.2860685 16.7451013,30.6818182 22.2153502,30.6818182 Z"
                                    id="椭圆形"
                                    stroke="#000000"
                                    strokeWidth="2.09462914"
                                ></path>
                                <path
                                    d="M22.0484216,35.5909092 C30.2537951,35.5909092 36.9055645,28.9972845 36.9055645,20.8636363 C36.9055645,12.7299882 30.2537951,6.13636363 22.0484216,6.13636363 C13.8430483,6.13636363 7.19127883,12.7299882 7.19127883,20.8636363 C7.19127883,28.9972845 13.8430483,35.5909092 22.0484216,35.5909092 Z"
                                    id="椭圆形备份-16"
                                    stroke="#000000"
                                    strokeWidth="2.09462914"
                                ></path>
                                <rect id="矩形" stroke="#000000" strokeWidth="2.09462914" x="0" y="0" width="44" height="54" rx="4.60795767"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
